import { logClient } from "./client";

const FilterForPlan = (data) => {
    return logClient.post('/ErrorLogModel/FilterForPlan',
        {
            "paginationParam": {
                "orderBy": data.orderBy,
                "orderDescending": data.orderDescending,
                "pageNumber": data.pageNumber,
                "pageSize": data.pageSize
            },
            "appLogicCode": data.appLogicCode,
            "from": data.from,
            "to": data.to
        }
    );
}

const logApi = { FilterForPlan }
export default logApi;